module.exports = __webpack_public_path__ + "img/numCard_SC.19c921d5.svg";